import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

export interface MobileMainNavLink {
  label: string;
  iconClass: string;
  routerLink: string;
}

@Component({
  selector: 'app-mobile-main-nav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './mobile-main-nav.component.html',
  styleUrls: ['./mobile-main-nav.component.css'],
})
export class MobileMainNavComponent {
  @Input() isOpen = false;
  @Input() links: MobileMainNavLink[] = [];

  @Output() closed = new EventEmitter<void>();

  constructor(private router: Router) {}

  close(): void {
    this.closed.emit();
  }

  onNavigate(): void {
    this.closed.emit();
  }

  closeTouchEnd(event: TouchEvent): void {
    event.preventDefault();
    this.close();
  }

  onNavigateTouch(link: MobileMainNavLink, event: TouchEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.onNavigate();
    this.router.navigate([link.routerLink]);
  }
}
